export const validateEmail = (email: any) => {
  if (!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
    return false;
  }
  return true;
};

export const validatePassword = (password: any) => {
  if (!/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/.test(password)) {
    return false;
  }
  return true;
};
